import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, persistStore, REGISTER, REHYDRATE } from 'redux-persist';
import authHeadersMiddleware from '../middleware/authHeadersMiddleware';
import persistReducer from './persistReducers';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: persistReducer(rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    }).concat(authHeadersMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production',
});

const persistor = persistStore(store);

export { persistor, store };
